export default __webpack_public_path__ + "static/media/const3.2fad2db0.jpg";